import axios from 'axios'

import { getApiUrl } from '../../util/api/api'
import type { ProductUpgrade } from '../../../state/reducers/entitlement/entitlement'

const requestJobUpgrade = (id: string, upgrade: ProductUpgrade): Promise<any> => {
  try {
    return axios.put(
      getApiUrl(`/api/v1/job/${id}/upgrade`),
      upgrade,
    )
  } catch (error) {
    throw new Error(`An error has occurred while requesting a job upgrade: ${error.message}`)
  }
}

export default requestJobUpgrade
